const index = {
  Z_INDEX_1: '100',
  Z_INDEX_2: '200',
  Z_INDEX_3: '300',
  Z_INDEX_4: '400',
  Z_INDEX_5: '500',
  Z_INDEX_6: '600',
  Z_INDEX_7: '700',
  Z_INDEX_8: '800',
  Z_INDEX_9: '900',
  Z_INDEX_10: '1000',
};

export default {
  header: index.Z_INDEX_9,
  header_gradient: index.Z_INDEX_9,

  main: index.Z_INDEX_2,

  nav: index.Z_INDEX_3,

  footer: index.Z_INDEX_1,
};



// WEBPACK FOOTER //
// ./src/identity/zIndex.js